module.exports = __webpack_public_path__ + "img/icon-arrow-left-alt.93c8fb79.svg";